//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/Expression.js";
import "../no/SelectFaceList.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"BooleanData",0,"GeometricUtilities.BooleanOperation",0],[0,"BoundingBoxBuilder",1,"Tooling.CreateBoxBuilder",1],[0,"BoxFaceToggle",1,0],[1,"Clearance",0,"Expression",0],[0,"FaceReverseDirection",1,0],[0,"RemoveParameter",1,0],[1,"SelFace",0,"SelectFaceList",0]],[[[],"EditBox",{},0,0],[["faceEid","state"],"ReverseFaceDirectionCallBack",{},2,0],[[],"UpdateForFaceChange",{},0,0],[["faceEid","reverse","faceForBoxFlag","action"],"UpdateFaceListState",{},4,0],[[],"GetBoundedBoxBuilder",{R_:{boxBuilder:"Features.ToolingBoxBuilder"}},0,0],[["boxBuilder"],"SetBoundedBoxBuilder",{},1,0]],[]];
SPLM.Tooling.ReplaceSolidBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ReplaceSolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;